import React from "react";
import { SubSectionHeader } from "../../../common/SubSectionHeader";
import { SectionContent } from "../../../common/SectionContent";
import { ImageContainer } from "../../../common/ImageContainer";

export const AddHistoricalPL = () => {
  return (
    <React.Fragment>
      <SubSectionHeader title="Add Historical P&L"
        id="historicalPL"
        >
        <SectionContent>
          <p>
          This feature is to import historical P&L data from your accounting software
           in a new tab of the input spreadsheet.  You can display only historical periods, 
           or combine historical and forecasted P&L in the same sheet. 
           These sheets can be referenced in forecast formulas.

          </p>
          <p>
          Note: A connection to your accounting software is required for this feature. 
          You can do this at: Track performance &gt; Configure data source (in the left navigation menu). 
          If the connection is terminated, you will not be able to import the latest version of 
          historical data from your accounting software.

          </p>
         
          <ImageContainer
                      fileName='add-historical-PL.png'
                      alt='add historical pl'   
                    />
        
        </SectionContent>
      </SubSectionHeader>
    </React.Fragment>
  );
};